// The common ways of mistyping a popular email provider. A suggestion is only ever offered, never applied.
const DOMAIN_FIXES: Record<string, string> = {
  'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gamil.com': 'gmail.com', 'gmail.co': 'gmail.com', 'gmail.con': 'gmail.com',
  'gnail.com': 'gmail.com', 'gmaill.com': 'gmail.com', 'gmal.com': 'gmail.com',
  'hotmial.com': 'hotmail.com', 'hotmai.com': 'hotmail.com', 'hotmail.con': 'hotmail.com', 'hotmal.com': 'hotmail.com',
  'outlok.com': 'outlook.com', 'outlook.con': 'outlook.com', 'outloook.com': 'outlook.com',
  'yahooo.com': 'yahoo.com', 'yaho.com': 'yahoo.com', 'yahoo.con': 'yahoo.com',
  'icloud.con': 'icloud.com', 'iclod.com': 'icloud.com',
}

/** A corrected address for an obvious typo in the domain, or null. */
export function suggestEmail(email: string): string | null {
  const trimmed = email.trim()
  const at = trimmed.lastIndexOf('@')
  if (at < 1) return null
  const fixed = DOMAIN_FIXES[trimmed.slice(at + 1).toLowerCase()]
  return fixed ? `${trimmed.slice(0, at)}@${fixed}` : null
}
